var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.635,
    height: 30.015,
    viewBox: "0 0 28.635 30.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "AdobeStock_65772719",
    d: "M225.746,214.591a15.349,15.349,0,0,0-9.35-11.333,9.35,9.35,0,0,1-9.618,0,15.345,15.345,0,0,0-9.349,11.333c-.175.85-.681,2.807,1.9,2.807h24.513C226.426,217.4,225.921,215.442,225.746,214.591Zm-14.193-12.147a7.531,7.531,0,1,0-7.532-7.531A7.531,7.531,0,0,0,211.553,202.444Z",
    transform: "translate(-197.269 -187.383)",
    fill: "#094400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinSide);
export default __webpack_public_path__ + "static/media/min_side.a1df7c014f14360ac3c812263a6ee9e5.svg";
export { ForwardRef as ReactComponent };